// Add a specific skill to a job  ******************************************************************
// pathname: v2/job-operation/job/{jobSlug}/skills/suggested/add
// ************************************************************************************************
import { ApiBulkApplyOk, useSwrMutationApi } from 'src/hooks/useSwrApi';


/**
 * @description SWR mutation: We use this SWR for handling the current skills of a job. When deleting one skill
 * from the list,we use this one to delete from a current job from slug.
 * @param jobSlug - string. The slug of the current job
 * @param locale - string. The locale to use for the request. Default: 'ro'.
 */


// ********************************************
export const useSwrDeleteSkillFromJob = (jobSlug:string, locale = 'ro') => {
  // SWR wrapper
  const {
    data, error, trigger, reset,
  } = useSwrMutationApi<ApiBulkApplyOk, object>({
    url: `/v2/job-operation/job/${jobSlug}/skills/delete`,
    locale,
    fetcherConfig: {
      method: 'DELETE',
      stringifyPayload: true,
    },
  });

  // return data
  return {
    data,
    error,
    trigger,
    reset,
  };
};
